export const popupsConfig = {
  popupFrequency: {
    ONCE: 1,
    EACH_PAGE_REFRESH: 2,
    EACH_PAGE_VIEW: 3,
    PER_DAY: 4,
  },
};
